import {
  INITIAL_STATE as initialStateActivationRequirements,
  default as reducersActivationRequirements
} from './activationRequirements'
import { INITIAL_STATE as initialStateAppFirstLoad, default as reducersAppFirstLoad } from './appFirstLoad'
import { INITIAL_STATE as initialStateCategories, default as reducersCategories } from './categories'
import { INITIAL_STATE as initialStateChargebacks, default as reducersChargebacks } from './chargebacks'
import { INITIAL_STATE as initialStateCharges, default as reducersCharges } from './charges'
import { INITIAL_STATE as initialStateCheckoutService, default as reducersCheckoutService } from './checkoutService'
import { INITIAL_STATE as initialStateContract, default as reducersContract } from './contract'
import { INITIAL_STATE as initialStateCustom, default as reducersCustom } from './custom'
import { INITIAL_STATE as initialStateEntities, default as reducersEntities } from './entities'
import { INITIAL_STATE as initialStateEvaluations, default as reducersEvaluations } from './evaluations'
import { INITIAL_STATE as initialStateFiles, default as reducersFiles } from './files'
import { INITIAL_STATE as initialStateGeographics, default as reducersGeographics } from './geographics'
import {
  INITIAL_STATE as initialStateMerchantCategoryCodes,
  default as reducersMerchantCategoryCodes
} from './merchantCategoryCodes'
import { INITIAL_STATE as initialStateOrders, default as reducersOrders } from './orders'
import { INITIAL_STATE as initialStatePaymentsApi, default as reducersPaymentsApi } from './paymentsApi'
import { INITIAL_STATE as initialStateQuizzes, default as reducersQuizzes } from './quizzes'
import { INITIAL_STATE as initialStateRoles, default as reducersRoles } from './roles'
import { INITIAL_STATE as initialStateStatement, default as reducersStatement } from './statement'
import { INITIAL_STATE as initialStateUser, default as reducersUser } from './user'
import { INITIAL_STATE as initialStateWizard, default as reducersWizard } from './wizard'
import { IReducerItem, IReducersAPICombined } from './interface'

export const initialStatesAPICombined: IReducerItem = {
  ...initialStateActivationRequirements,
  ...initialStateAppFirstLoad,
  ...initialStateCategories,
  ...initialStateChargebacks,
  ...initialStateCharges,
  ...initialStateCheckoutService,
  ...initialStateContract,
  ...initialStateCustom,
  ...initialStateEntities,
  ...initialStateEvaluations,
  ...initialStateFiles,
  ...initialStateGeographics,
  ...initialStateMerchantCategoryCodes,
  ...initialStateOrders,
  ...initialStatePaymentsApi,
  ...initialStateQuizzes,
  ...initialStateRoles,
  ...initialStateStatement,
  ...initialStateUser,
  ...initialStateWizard
}

export const reducersAPICombined: IReducersAPICombined = {
  ...reducersActivationRequirements,
  ...reducersAppFirstLoad,
  ...reducersCategories,
  ...reducersChargebacks,
  ...reducersCharges,
  ...reducersCheckoutService,
  ...reducersContract,
  ...reducersCustom,
  ...reducersEntities,
  ...reducersEvaluations,
  ...reducersFiles,
  ...reducersGeographics,
  ...reducersMerchantCategoryCodes,
  ...reducersOrders,
  ...reducersPaymentsApi,
  ...reducersQuizzes,
  ...reducersRoles,
  ...reducersStatement,
  ...reducersUser,
  ...reducersWizard
}
